export default __webpack_public_path__ + "static/media/wechat-pay-logo.dd35d20b.svg";